function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
        return;
        
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt       = this.countryEl.options[this.countryEl.selectedIndex];
        var raw       = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

Shopify.getCart = function(callback) {
    $.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
    });
}

Shopify.onCartUpdate = function(cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
}

Shopify.changeItem = function(variant_id, quantity, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity='+quantity+'&id='+variant_id,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };

    $.ajax(params);
}

Shopify.removeItem = function(variant_id, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity=0&id='+variant_id,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };

    $.ajax(params);
}

Shopify.addItem = function(variant_id, quantity, callback, input = null) {
    var quantity = quantity || 1;
    var target = document.querySelector('[data-quickshop] .is-loading') || document.querySelector('[data-btn-addtocart].is-loading');
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            var message = window.cartStrings.addProductOutQuantity2;
            if (input.length > 0) {
                var maxValue = parseInt(input.attr('data-inventory-quantity'));
                message = getInputMessage(maxValue)
                input.val(maxValue)
            } 
            
            Shopify.onError(XMLHttpRequest, textStatus, message);
            target?.classList.remove('is-loading');
        }
    };
    $.ajax(params);
}

Shopify.onItemAdded = function(line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

Shopify.onError = function(XMLHttpRequest, textStatus, message) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        !!data.description ? showWarning(data.description) : showWarning(data.message + ': ' + message, warningTime);
    } else {
        showWarning('Error : ' + message, warningTime);
    }
}
window.Shopify.getProductHTML = function (productJson) {
    
    let productHTML = '<div class="product">'+
    '<div class="card product-item" data-product-id="[[product_id]]" data-json-product="[[product_json]]">'+
        '<div class="card-product card-product__wrapper">'+
            '<div class="card__badge badge-right halo-productBadges halo-productBadges--right date-5788396 date1-66" data-new-badge-number="30">'+
                '[[new_label]]'+
                '<div style="display: flex; flex-direction: column;">[[labels]]</div>'+
            '</div>'+
            '<a class="card-media card-media--square media--hover-effect" href="[[product_url]]">'+
                '[[image_content]]'+
                '<span class="data-lazy-loading"></span>'+
            '</a>'+
            '<div class="card-quickview">'+
                '[[quick_options]]'+
            '</div>'+
        '</div>'+
        '<div class="card-information has-wishlist card-information__wrapper text-left">'+
            '<div class="card-information__group card-information__group-2 has-wishlist">'+
                '<div class="card-vendor">'+
                    '<a href="[[vendor_url]]" title="Casio">[[vendor]]</a>'+
                '</div>'+
                '<div class="card-wishlist wishlist-icon" data-wishlist="" data-wishlist-handle="[[product_handle]]" data-product-id="[[product_id]]" data-count="..." data-pending="0" data-params=\'{"product_id":"[[product_id]]","event":"fave","page":"product_profile"}\'>'+
                    '<svg x="0px" y="0px" viewBox="0 0 102.9 89.2" style="enable-background:new 0 0 102.9 89.2;" xml:space="preserve" class="header-icon header-icon-wishlist">'+
                        '<use xlink:href="#icon-wishlist-new"></use>'+
                    '</svg>'+
                '</div>'+
            '</div>'+
            '<a class="card-title link-underline card-title-ellipsis" href="[[product_url]]" data-product-title="[[product_title]]" data-product-url="[[product_url]]">[[product_title]][[product_title_option]]</a>'+
            '<div class="price card-price  price--on-sale ">'+
                '[[product_price]]'+
                '[[product_cprice]]'+
            '</div>'+
            '<div class="card-swatch text-left clearfix" id="product-swatch-[[product_id]]" style="min-height: 25px">[[product_swatches]]</div>'+
        '</div>'+
    '</div>'+
    '</div>',
    badgeHTML = '<span class="badge [[badge_class]]" aria-hidden="true">[[new_label]]</span>',
    imageHTML = '<img src="[[image_src]]" sizes="299px" alt="[[image_alt]]" loading="lazy" class="lazyautosizes motion-reduce lazyloaded" style="--background-image: url([[image_src]])">',
    priceHTML = '<span class="price-item">[[price_from]]<span class="money">[[product_price]]</span></span>',
    cpriceHTML = '<s class="price__compare price-item price-item--regular"><span class="money">[[product_cprice]]</span></s>',
    swatchesContainerHTML = '<ul class="swatch list-unstyled">[[swatches]]</ul>',
    swatchLiHTML = '<li class="item"><div class="item-wrapper clearfix"><label data-with-one-option="[[variant_id]]" data-quantity="1" class="swatch-label [[is_active]]" data-value="[[option_name]]" data-variant-id="[[variant_id]]" title="[[option_name]]" data-variant-img="[[variant_img]]">'+
    '<span class="pattern">' +
    '<img style="border-radius: var(--product-swatch-color-border-radius);" data-img-src="[[sn_img]]" src="[[sn_img]]" sizes="auto" onerror="this.onerror=null;this.src=\'[[variant_img]]\';">' +
    '</span></label><span class="tooltip">[[option_name]]</span></div>',
    swacthRestHtml = '<li class="item-swatch-more item"><button type="button" class="number-showmore" title="More Color"><span>+</span> <span class="text-number">[[swatch_rest_count]]</span></button></li>',
    quickAddHTML = '<button type="submit" name="add" data-variant_id="[[variant_id]]" data-btn-addtocart="" data-available="" class="quickview-button button" id="product-add-to-cart"> Quick Add </button>',
    quickAddMultiVariantHTML = '<button type="button" title="Quick View" class="quickview-button button" data-product-id="[[product_id]]" data-open-quick-view-popup="" data-product-handle="[[product_handle]]"> Quick Add </button>',
    notifyMeHTML = '<button type="button" title="[[product_title]]" class="quickview-button button is-notify-me" data-product-id="[[product_id]]" data-btn-addToCart data-product-handle="[[product_handle]]"> Notify Me </button>',
    quickViewHTML = '<button type="button" title="Quick View" class="quickview-button button" data-product-id="[[product_id]]" data-open-quick-view-popup="" data-product-handle="[[product_handle]]"> Quick View </button>';

    let labels = "",
    new_label = "",
    product_price = "",
    product_cprice = "",
    product_swatches = "",
    product_swatch_name = "",
    quick_options = "",
    currency = "KWD",
    newProduct = false;

    const escapeRegExp = function(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }

    //Quick options  
    if (productJson.available) {
        if (productJson.variants.length > 1) {
            quick_options += quickAddMultiVariantHTML.replace("[[product_id]]", productJson.id)
            .replace("[[product_handle]]", productJson.handle);
        } else {
            quick_options += quickAddHTML.replace("[[variant_id]]", productJson.variants[0].id)
            .replace("[[product_handle]]", productJson.handle);
        }
    } else {
        quick_options += notifyMeHTML.replace("[[product_id]]", productJson.id)
        .replace("[[product_title]]", productJson.title)
        .replace("[[product_handle]]", productJson.handle);
    }
    quick_options += quickViewHTML.replace("[[product_id]]", productJson.id)
    .replace("[[product_handle]]", productJson.handle);


    //Swatch logics
    if (productJson.variants.length > 0) {


        const invalidChars = '\/:*?"<>|!\';@&=+$,%#[] ';
        const swatch_regex = new RegExp('[' + invalidChars.split('').map(c => '\\' + c).join('') + ']', 'g');

        const colorOption = productJson.options_with_values.filter( e => e.name.toLowerCase() == "color");
        let swatches = "";
        if (colorOption && colorOption.length > 0) {
            let color_index = 0;
            for ( color of colorOption[0].values) {
                let index = 0,
                liBlock = "",
                selectedVariant = null;
                for ( variant of productJson.variants) {
                    if (index == 0) {
                        //product_swatch_name = swacthNameHtml.replace("[[variant_title]]", color.title);
                    }
                    if (variant.title.indexOf(color.title) !== -1) {
                        if (selectedVariant == null || (selectedVariant.image == "" && !selectedVariant.available && (variant.image != "" || variant.available)) ) {
                            selectedVariant = variant;
                        }
                    }
                    index++;
                }

                if (selectedVariant != null) {

                    let sanitized = selectedVariant.title.replace(swatch_regex, "-");
                    sanitized = "btsi_" + productJson.id + "_" + sanitized + ".jpg"
                    sanitized = sanitized.replace(/-\.jpg/g, 'jpg');
                    sanitized = window.shop_url + "/cdn/shop/files/" + sanitized


                    liBlock = swatchLiHTML.replace(new RegExp(escapeRegExp("[[variant_id]]"), 'g'), selectedVariant.id)
                    .replace("[[is_active]]", index == 0 ? "is-active" : "")
                    .replace(new RegExp(escapeRegExp("[[option_name]]"), 'g'), selectedVariant.title)
                    .replace(new RegExp(escapeRegExp("[[option_hex_name]]"), 'g'), color.title.toLowerCase())
                    .replace(new RegExp(escapeRegExp("[[variant_class_name]]"), 'g'), productJson.handle+ "-"+color_index)
                    .replace(new RegExp(escapeRegExp("[[variant_img]]"), 'g'), selectedVariant.image)
                    .replace(new RegExp(escapeRegExp("[[sn_img]]"), 'g'), sanitized);
                    swatches += liBlock;
                }
                if (color_index == 3) break;
                color_index++;
            }
            const sw_count = colorOption[0].values.length
            if (sw_count > 4) {
                const rest_liBlock = swacthRestHtml.replace(new RegExp(escapeRegExp("[[swatch_rest_count]]"), 'g'), sw_count - 4);
                swatches += rest_liBlock;
            }

        }
        product_swatches = swatchesContainerHTML.replace("[[swatches]]", swatches);
    }

    //badge logics
    //soldout
    if(!productJson.available) {
        labels += badgeHTML.replace("[[new_label]]", "Sold Out")
        .replace("[[badge_class]]", "sold-out-badge");
    }
    //sale
    if(productJson.compare_at_price_min && productJson.compare_at_price_min > productJson.price_min) {
        let sale_value = Math.round((productJson.compare_at_price_min - productJson.price_min) *100 / productJson.compare_at_price_min);
        labels += badgeHTML.replace("[[new_label]]", "Sale " + sale_value + "%")
        .replace("[[badge_class]]", "sale-badge");
    }
    //new
    const measureTimestamp = new Date().getTime() - (30 * 24 * 60 * 60 * 1000);
    const productCreatedTimestamp =  new Date().getTime(productJson.created_at);
    newProduct = productCreatedTimestamp > measureTimestamp ? true : false;
    if (newProduct) {
        new_label = badgeHTML.replace("[[new_label]]", "New")
        .replace("[[badge_class]]", "new-badge");
    }

    //price logics
    product_price = priceHTML.replace(new RegExp(escapeRegExp("[[product_price]]"), 'g'), productJson.price_min + " " + currency)
    if (productJson.price_min == productJson.price_max) {
        product_price = product_price.replace(new RegExp(escapeRegExp("[[price_from]]"), 'g'), "");
    } else {
        product_price = product_price.replace(new RegExp(escapeRegExp("[[price_from]]"), 'g'), '<span class="text">From</span>');
    }
    if (productJson.compare_at_price_min != null && productJson.price_min != productJson.compare_at_price_min) {
        product_cprice = cpriceHTML.replace(new RegExp(escapeRegExp("[[product_cprice]]"), 'g'), productJson.compare_at_price_min + " " + currency);
        product_price = product_price.replace("price-item", 'price-item price-item--sale'); 
    } else {
        product_cprice = cpriceHTML.replace(new RegExp(escapeRegExp("[[product_cprice]]"), 'g'), '');
    }

    //images
    let image_content = "";
    if ( productJson.images_info.length > 0 ) {
        let img_url = productJson.images_info[0].src + "?width=240"
        let img_alt = productJson.images_info[0].alt
        if (img_alt == null || img_alt == "") {
            img_alt = productJson.title
        }
        image_content += imageHTML.replace(new RegExp(escapeRegExp("[[image_src]]"), 'g'), img_url).replace("[[image_alt]]", img_alt);
        if ( productJson.images_info.length > 1 ) {
            img_url = productJson.images_info[1].src + "?width=240"
            img_alt = productJson.images_info[1].alt
            if (img_alt == null || img_alt == "") {
                img_alt = productJson.title
            }
            image_content += imageHTML.replace(new RegExp(escapeRegExp("[[image_src]]"), 'g'), img_url).replace("[[image_alt]]", img_alt);
        }
    }

    //product_id
    return productHTML.replace(new RegExp(escapeRegExp("[[product_id]]"), 'g'), productJson.id)
    //product_handle
    .replace(new RegExp(escapeRegExp("[[product_handle]]"), 'g'), productJson.handle)
    //product_json
    //.replace("[[product_json]]", productJson)
    //product_title
    .replace(new RegExp(escapeRegExp("[[product_title]]"), 'g'), productJson.title)
    //product_title
    .replace(new RegExp(escapeRegExp("[[product_title_option]]"), 'g'), product_swatch_name)
    //product_url
    .replace(new RegExp(escapeRegExp("[[product_url]]"), 'g'), "/products/"+productJson.handle)
    //variant_id
    .replace(new RegExp(escapeRegExp("[[variant_id]]"), 'g'), productJson.variants[0].id)
    //vendor
    .replace(new RegExp(escapeRegExp("[[vendor]]"), 'g'), productJson.vendor)
    //vendor_url
    .replace(new RegExp(escapeRegExp("[[vendor_url]]"), 'g'), productJson.vendor_url)
    //badges
    .replace(new RegExp(escapeRegExp("[[new_label]]"), 'g'), new_label)
    //all badges
    .replace(new RegExp(escapeRegExp("[[labels]]"), 'g'), labels)
    //image_content
    .replace(new RegExp(escapeRegExp("[[image_content]]"), 'g'), image_content)
    //image_content
    .replace(new RegExp(escapeRegExp("[[product_price]]"), 'g'), product_price)
    //image_content
    .replace(new RegExp(escapeRegExp("[[product_cprice]]"), 'g'), product_cprice)
    //product_json
    .replace(new RegExp(escapeRegExp("[[product_json]]"), 'g'), JSON.stringify(productJson).replace(new RegExp(escapeRegExp("\""), 'g'), '&quot;'))
    //product_json
    .replace(new RegExp(escapeRegExp("[[product_swatches]]"), 'g'), product_swatches)
    //quick_options
    .replace(new RegExp(escapeRegExp("[[quick_options]]"), 'g'), quick_options);

}


class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if(event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if(!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if(isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    
    onButtonClick(event) {
        event.preventDefault();
        let el_input = event.target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        if (event.target.classList.contains('plus')) {
            var newVal = value + 1;
        } else {
            var newVal = value - 1;
        }

        if (newVal < 0 ) {
            var newVal = 1
        }

        if (newVal <= inStockNumber) {
            el_input.value = newVal;
            this.input.dispatchEvent(this.changeEvent);
        } else if (isNaN(inStockNumber)) {
            el_input.value = newVal;
            this.input.dispatchEvent(this.changeEvent);
        }  else {
            if (this.quantityCheckedToBeContinue()) {
              el_input.value = newVal;
              this.input.dispatchEvent(this.changeEvent);
              return;
            }
          
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            var newVal = inStockNumber
            el_input.value = newVal;
        }
    }

    quantityCheckedToBeContinue() {
        const sellingArray = window[`cart_selling_array_${this.dataset.product}`];
        return sellingArray[this.querySelector('[name="quantity"]').dataset.cartQuantityId] === 'continue';
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onChangeQuantity.bind(this))
        );
        this.input.addEventListener('change', this.onChangeQuantity.bind(this))
    }
    
    onChangeQuantity(event) {
        event.preventDefault();
        const target = event.target;
        let el_input = target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = target.closest('[data-quickshop]').querySelector('[data-btn-addtocart]');
        let newVal;

        if (target.matches('.plus')) newVal = value + 1;
        else if (target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal <= 0) newVal = 1;

        if (newVal > inStockNumber && !buttonAdd.matches('.button--preorder')) {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            newVal = inStockNumber
        }
        
        el_input.value = newVal;
        if (target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent);
        const quickshop = this.closest('[data-quickshop]');
        const realQuantityInput = quickshop.querySelector('form input[type="hidden"]');
        realQuantityInput.setAttribute('value', newVal);
    }
}

class ScrollerBlock extends HTMLElement {
    constructor() {
        super();    
        this.buttons = [...this.querySelectorAll('[data-btn-type]')];
        this.tabLinks = [...this.querySelectorAll('[data-product-tabTop]')];
        this.tabContents = [...this.querySelectorAll('[data-product-tabContent]')];

        this.initProductTabClick();
        this.initClickToScroll();
    }


    initClickToScroll() {
        if (this.tabContents.length > 0) {
            this.buttons.forEach(button => {
                button.addEventListener('click', this.handleScrollButtonClick.bind(this))
            })
        }
    }

    handleScrollButtonClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.scrollContainer) {
            let scrollToX = 0, 
            directionMultiplr = e.currentTarget.dataset.btnType == 'next' ? 1 : -1,
            maxOffset = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;

            scrollToX = this.scrollContainer.scrollLeft + (this.scrollContainer.clientWidth * directionMultiplr);
            scrollToX = (scrollToX > maxOffset) ? maxOffset : (scrollToX < 0) ? 0 : scrollToX;
            //this.scrollContainer.scrollLeft = scrollToX;
            gsap.to(this.scrollContainer, {duration: .5, scrollTo: {x: scrollToX}, ease: "power2.inOut"});
        }
    }
    
    initProductTabClick() {
        this.linkActive = this.tabLinks.find(tabLink => tabLink.classList.contains('active'));
        this.activeTabContent = this.tabContents.find(tabContent => tabContent.classList.contains('active'));
        this.scrollContainer = (this.activeTabContent.firstElementChild||this.activeTabContent.firstChild)

        //this.handleAfterClick();

        this.tabLinks.forEach(tabLink => {
            tabLink.addEventListener('click', this.handleTabClick.bind(this))
        })
    }
    

    handleTabClick(e) {
        e.preventDefault();
        e.stopPropagation(); 

        const clickedTabLink = e.target

        if (clickedTabLink.classList.contains('active')) return 

        this.linkActive.classList.remove('active');
        this.activeTabContent.classList.remove('active'); 

        const currentTabContent = this.querySelector(clickedTabLink.dataset.target);

        clickedTabLink.classList.add('active');
        currentTabContent.classList.add('active');

        this.linkActive = clickedTabLink 
        this.activeTabContent = currentTabContent
        this.scrollContainer = (this.activeTabContent.firstElementChild||this.activeTabContent.firstChild)

        //this.handleAfterClick();
    }
}

class ImageSlider extends HTMLElement {
    constructor() {
        super();    
        this.activeSlide = 0;
        this.nextSlide = 0;
        this.timer = 0;
        this.enableAutoplay = false;
        this.interval = 3;
        this.container = this.querySelector('.mini-images-banner');
        this.slides = [...this.querySelectorAll('[data-image-slide]')];
        this.buttons = [...this.querySelectorAll('[data-btn-type]')];

        this.initImageSlider();
        this.initClickToScroll();
        this.initSwipeScroll();
    }
    
    initImageSlider() {
        this.enableAutoplay = this.container.dataset.enable_autoplay        ,
        this.interval = this.container.dataset.interval;
        if (this.enableAutoplay) this.timer = setInterval(this.slideImage.bind(this), this.interval*1000);
    }

    slideImage(direction = 1) {
        this.nextSlide = ((this.activeSlide + direction) == this.slides.length) ? 0 : ((this.activeSlide + direction) < 0) ? this.slides.length - 1 : this.activeSlide + direction;
        this.slides[this.activeSlide].style.opacity = 0;
        this.slides[this.nextSlide].style.opacity = 1;
        this.slides[this.activeSlide].style.zIndex = 0;
        this.slides[this.nextSlide].style.zIndex = 1;
        this.activeSlide = this.nextSlide;
    }


    initClickToScroll() {
        if (this.slides.length > 0) {
            this.buttons.forEach(button => {
                button.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    const direction = e.currentTarget.dataset.btnType == 'next' ? 1 : -1;
                    this.handleScrollEvent(direction)
                })
            })
        }
    }

    initSwipeScroll() {
        if (this.slides.length > 0) {
            this.container.addEventListener('swiped-left', e => this.handleScrollEvent(1));
            this.container.addEventListener('swiped-right', e => this.handleScrollEvent(-1));
        }
    }

    handleScrollEvent(direction) {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        this.slideImage(direction);
        if (this.enableAutoplay) this.timer = setInterval(this.slideImage.bind(this), this.interval*1000);
    }
}

class ImageToFlip extends HTMLElement {
    constructor() {
        super() 

        this.imageContainer = this; 
        this.initObserver();
    }   

    initObserver() {
        this.observer = new IntersectionObserver((entries, observer) => {
            const imageRef = entries[0]

            if (imageRef.isIntersecting) {
                imageRef.target.classList.add('show')
                observer.unobserve(imageRef.target)
            }

        }, 
        {
            threshold: 0.4 
        });
        
        this.observer.observe(this.imageContainer);
    }
}

window.addEventListener('load', () => {
    customElements.define('cart-update-quantity', UpdateQuantity);
    customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
    customElements.define('scroller-block', ScrollerBlock);
    customElements.define('dynamic-block', DynamicBlock);
    customElements.define('image-slider', ImageSlider);
    customElements.define('product-view-images', ProductViewImages);
    customElements.define('image-to-flip', ImageToFlip);
})

function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

class FadeInComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initObserver();
    }

    initObserver() {
        const handler = (entries, observer) => {
            if (entries[0].isIntersecting) {
                this.classList.add('fade-in');

                observer.unobserve(this);
            }
        }

        const options = {
            threshold: 0.7
        }

        this.observer = new IntersectionObserver(handler, options); 
        this.observer.observe(this);
    }
}

class ProductViewImages extends HTMLElement {
    constructor() {
        super();    
        this.productThumbs = [...this.querySelectorAll('.product-mini-thumbs-scroll img')];
        this.productPreviews = [...this.querySelectorAll('.product-mini-images .media')];
        this.imageContainer = this.querySelector('.product-mini-images');
        this.scrollContainer = this.querySelector('.product-mini-thumbs-scroll');
        this.imageScrollContainer = this.querySelector('.product-mini-images .preview-scroller');
        this.buttons = [...this.querySelectorAll('[data-btn-type]')];
        this.currentPreview = this.productPreviews[0];
        this.currentThumb = this.productThumbs[0];
        this.throttleT = false;
        this.productPreviewWidth = null;

        this.initImageMappings();
        this.initClickToScroll();
        this.initSwipeScroll();
    }
    
    initImageMappings() {
        if (this.productPreviews.length > 0) 
            this.currentPreview = this.productPreviews.find(preview => preview.classList.contains("show-preview"));
        if (this.productThumbs.length > 0) {
            this.currentThumb = this.productThumbs.find(thumb => thumb.classList.contains("show-preview"));
            this.productThumbs.forEach(imageThumb => {
                imageThumb.addEventListener('click', e => this.showPreview(e));
            });
        } 
    }
    initSwipeScroll() {
        if (this.productPreviews.length > 0) {
            this.imageScrollContainer.addEventListener('scroll', e => this.handleScrollEvent());
        }
    }

    handleScrollEvent() {

        if (this.throttleT) return;
    
        this.throttleT = true;
        setTimeout(() => {
            if (window.innerWidth < 991) {

                let prevEleW = this.imageScrollContainer.scrollWidth / this.productPreviews.length;
                let scrollTo = this.imageScrollContainer.offsetLeft / prevEleW;
                console.log("this.imageScrollContainer.scrollWidth: " + this.imageScrollContainer.scrollWidth);
                console.log("this.productPreviews.length: " + this.productPreviews.length);
                console.log("this.imageScrollContainer.offsetLeft: " + this.imageScrollContainer.offsetLeft);
                console.log("testing: " + scrollTo);
                
            }
            this.throttleT = false;
        }, 500);
        

    }

    showPreview(e) {
        let mediaId = e.currentTarget.dataset.mediaId;
        if (mediaId.length > 0) {
            let ids = mediaId.split("-");
            let id = ids[ids.length - 1];
            if (this.productPreviews.length > 0) {
                let previewToShow = this.productPreviews.find(imagePreview => (imagePreview.dataset.mediaId == ("preview-"+id)));
                if (previewToShow) {
                    this.currentPreview.classList.remove("show-preview");
                    previewToShow.classList.add("show-preview");
                    this.currentPreview = previewToShow;
                    this.currentThumb.classList.remove("show-preview");
                    e.currentTarget.classList.add("show-preview");
                    this.currentThumb = e.currentTarget;
                }
            } 

            
            if (window.innerWidth > 991) {
                let maxOffset = this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight;
                let scrollTo = (e.currentTarget.offsetTop - 
                    (this.scrollContainer.clientHeight + e.currentTarget.clientHeight)/2 + 
                    e.currentTarget.clientHeight);
                scrollTo = (scrollTo > maxOffset) ? maxOffset : (scrollTo < 0) ? 0 : scrollTo;
                gsap.to(this.scrollContainer, {duration: .5, scrollTo: {y: scrollTo}, ease: "power2.inOut"});
            } else {
                
                let maxOffset = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
                let scrollTo = (e.currentTarget.offsetLeft - 
                    (this.scrollContainer.clientWidth + e.currentTarget.clientWidth)/2 + 
                    e.currentTarget.clientWidth);
                scrollTo = (scrollTo > maxOffset) ? maxOffset : (scrollTo < 0) ? 0 : scrollTo;
                gsap.to(this.scrollContainer, {duration: .5, scrollTo: {x: scrollTo}, ease: "power2.inOut"});
            }
        }
    }
    initClickToScroll() {
        if (this.buttons.length > 0) {
            this.buttons.forEach(button => {
                button.addEventListener('click', this.handleScrollButtonClick.bind(this))
            })
        }
    }

    handleScrollButtonClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (this.scrollContainer) {
            let scrollTo = 0,
            directionMultiplr = e.currentTarget.dataset.btnType == 'next' ? 1 : -1;
            if (window.innerWidth > 991) {
                let maxOffset = this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight;
                scrollTo = this.scrollContainer.scrollTop + (this.scrollContainer.clientHeight * directionMultiplr);
                scrollTo = (scrollTo > maxOffset) ? maxOffset : (scrollTo < 0) ? 0 : scrollTo;
                //this.scrollContainer.scrollTop = scrollTo;
                gsap.to(this.scrollContainer, {duration: .5, scrollTo: {y: scrollTo}, ease: "power2.inOut"});
            } else {
                let maxOffset = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
                scrollTo = this.scrollContainer.scrollLeft + (this.scrollContainer.clientWidth * directionMultiplr);
                scrollTo = (scrollTo > maxOffset) ? maxOffset : (scrollTo < 0) ? 0 : scrollTo;
                //this.scrollContainer.scrollLeft = scrollTo;
                gsap.to(this.scrollContainer, {duration: .5, scrollTo: {x: scrollTo}, ease: "power2.inOut"});
            }
        }
    }
}
class DynamicBlock extends HTMLElement {
    constructor() {
        super();
        this.sectionId = this.dataset.sectionId
        this.localStorageKey = 'boostSDRecentlyViewedProduct';
        this.container = this.querySelector('[data-scroll-container]');
        this.productIds = this.dataset.productIds.split(",");
        this.boostType = this.dataset.dynamicType;
        this.boostPageType = this.dataset.dynamicPageType; 
        this.boostWidid = this.dataset.dynamicWidid;
        this.fallbackProductIds = this.dataset.fallbackProductIds;
        this.products = [];
        this.productHandles = [];
        this.DEFAULT_LOCALE = "en"
        this.shop = "blinktrends-com-4.myshopify.com";

        this.initDynamicProductBlock();
    }


    async initDynamicProductBlock() {

        const boostWidgetSettings = window.boostSDRecommendationConfig.widgets[this.boostPageType][this.boostWidid];
        
        let params = {},
        body = {};
        

        // set Product IDs
        if (this.boostType == "rvi") {
            this.productIds = this.getRecentlyViewedProducts();
            this.productIds = [...new Set(this.productIds)];
            if (this.productIds.length < 6 && this.fallbackProductIds) {
                const fallbackProductIdArray = this.fallbackProductIds.split(",");
                this.productIds = this.productIds.concat(fallbackProductIdArray);
            }
        } else {
            if (this.boostPageType === 'cart') {
                this.productIds = await this.getCartItems();
            } else if (this.boostPageType === 'product') {
                this.productIds = [window.boostSDAppConfig?.generalSettings?.product_id];
            }
        }
        // build param and body list
        const omit = (obj, keys) => 
            Object.fromEntries(
                Object.entries(obj)
                .filter(([k]) =>  {
                   return !keys.includes(k);
                })
            );
        const pick = (obj, keys) => 
            Object.fromEntries(
                Object.entries(obj)
                .filter(([k]) => keys.includes(k))
            );
            
        if (boostWidgetSettings) {
            params = {
                    ...pick(boostWidgetSettings.params, ['recommendationType', 'limit', 'shop', 'wid']),
                };

            const productIds = this.productIds;
            body = {
                ...omit(boostWidgetSettings.params, ['tenantId']),
                productIds,
                }
        }
        let products = await this.getBoostProductsList (params, body);

        if (products) {
            this.products = products.products;
        }
        if (!this.products) {
            this.products = this.defaultProductsCollection();
        }
        if (this.products.length > 0) {
            await this.renderProductHandleList(this.products);
            this.bindEvents();
        } else {
            const section = document.querySelector("#shopify-section-"+this.sectionId);
            section.style.display = 'none';
        }
    }

    bindEvents () {
        [...this.querySelectorAll('[data-wishlist-handle]')].forEach (wishlistIcon => {
            wishlistIcon.addEventListener('click', window.sswcustom.bind.wishlistIcon.bind(this))
        });
    }


    getProductHandles (products) {
        return products.map( (product) => product.handle);
    }

    async getBoostProductsList (params, body) {
        const { recommendUrl } = window.boostSDAppConfig?.api || {};
        const API_URL = recommendUrl || 'https://staging.bc-solutions.net/discovery/recommend';

        const currentPage = this.getCurrentPage();
        params = {
            ...params,
            locale: this.DEFAULT_LOCALE,
            event_type: 'init',
            pg: currentPage,
        };
        params = this.addParamsLocale(params);
        const queryParams = new URLSearchParams(params);
    
        body = {
            ...body,
            locale: this.DEFAULT_LOCALE,
            pg: currentPage,
        };
      
        body = this.addParamsLocale(body);
        const response = await fetch(`${API_URL}?${queryParams}`, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return await response.json();
    }

    getCurrentPage () {
        let currentPage = '';
      
        switch (this.boostPageType) {
          case "collection":
            currentPage = 'collection_page';
            break;
      
          case "search":
            currentPage = 'search_page';
            break;
      
          case "product":
            currentPage = 'product_page';
            break;
      
          case "cart":
            currentPage = 'cart_page';
            break;
      
          case "home":
            currentPage = 'home_page';
            break;
      
          default:
            break;
        }
        return currentPage;
    }

    addParamsLocale (params) {
        if (parseFloat(`${window.Shopify?.currency?.rate}`) === 1) return params;
        return {
            ...params,
            currency_rate: window.Shopify?.currency?.rate,
            currency: window.Shopify?.currency?.active,
            country: window.Shopify?.country,
            return_all_currency_fields: false,
        }
    }

    async renderProductHandleList(products) {

        if (products.length > 0) {
            const products_array = Array.from(products);
            let innerHTML = "";
            for (const product of products){
                innerHTML += Shopify.getProductHTML(product);
            }
            this.container.innerHTML = innerHTML;
            window.halo.initQuickView();
        }
    }
      
    getRecentlyViewedProducts () {
    
        const productsRaw = window.localStorage.getItem(this.localStorageKey);
        if (!productsRaw) return [];
        
        return JSON.parse(productsRaw);
    }

    defaultProductsCollection() {
        return [];
    }
    async getCartItems () {
        let productIds = [];

        const response = await fetch(`/cart.js`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const cartJson = await response.json();
        if (cartJson && cartJson.items && cartJson.items.length > 0 ) {
            productIds = cartJson.items.map( e => e.product_id);
        }
        return productIds;
    }
}

window.addEventListener('load', () => {
    customElements.define('fade-in-component', FadeInComponent);
})

var countHtmlElements = function (query) {
    var slides = [...document.querySelectorAll(query)];
    console.log ("all products: " + slides.length);
    var all_elements = 0;
    slides.forEach(slide => {
        var numberOfChildren = slide.getElementsByTagName('*').length;
        all_elements += numberOfChildren;
        console.log ("id: " + slide.dataset.productId + ". elements: " + numberOfChildren);
    })
    console.log ("All Elements in Products: " + all_elements);
}